<div>
  <canvas baseChart [data]="data()" [options]="options()" [type]="type()" [plugins]="plugins() || []"></canvas>
</div>
